import React from "react";
import { Routes, Route } from "react-router-dom";
import ComparisonSection from "./ComparisonSection";
import FounderNarrative from "./FounderNarrative";
import DonatePage from "./DonatePage";
import SEO from "./components/SEO";

const App = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <SEO 
              title="Donate Your Body | Alternative to Donating Your Body to Science | MASS BODY"
              description="MASS BODY is a legally structured body donation program offering an alternative to donating your body to science, focused on ecological art, decomposition, and environmental continuity. Donate your body after death to an ecological art project."
              url="https://massbody.org"
            />
            <main className="w-full bg-white">
              <ComparisonSection />
              <FounderNarrative />
            </main>
          </>
        }
      />
      <Route 
        path="/donate" 
        element={
          <>
            <SEO 
              title="Donate Your Body | An Alternative to Donating Your Body to Science | MASS BODY"
              description="Donate your body as an alternative to traditional body donation programs, through an ecological art project studying human decomposition. Learn about eligibility, consent process, costs, and what happens to remains. Legally structured body donation program."
              url="https://massbody.org/donate"
            />
            <DonatePage />
          </>
        } 
      />
    </Routes>
  );
};

export default App;
 